<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="50" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="0">
          <ElInput v-model="keyword" placeholder="人群包ID/名称" style="width: 160px" @keyup.enter.native="sendEvent">
            <i slot="append" @click="sendEvent" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem label-width="38" label="平台">
          <el-select v-model="platform" :popper-append-to-body="false" clearable filterable placeholder="全部" style="width: 120px">
            <el-option v-for="item in platformData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="创建人">
          <el-select v-model="opId" :popper-append-to-body="false" clearable filterable placeholder="全部" style="width: 120px">
            <el-option v-for="item in SYS_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="更新人">
          <el-select v-model="upId" :popper-append-to-body="false" clearable filterable placeholder="全部" style="width: 120px">
            <el-option v-for="item in SYS_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label-width="38" label="状态">
          <el-select v-model="stats" :popper-append-to-body="false" clearable filterable placeholder="全部" style="width: 120px">
            <el-option v-for="item in statData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <ElButton type="primary" style="margin-right: 10px" @click="sendEvent" :loading="loading">查询</ElButton>
          <ElDropdown @command="onDropdownCmd">
            <ElButton>
              批量操作
              <i class="el-icon-arrow-down"></i>
            </ElButton>
            <ElDropdownMenu slot="dropdown">
              <ElDropdownItem command="1" v-if="this.authBatchBtn">批量推送DMP</ElDropdownItem>
              <ElDropdownItem command="2">批量删除</ElDropdownItem>
            </ElDropdownMenu>
          </ElDropdown>
          <ElButton type="primary" style="margin-left: 10px" @click="autoUpload('autoupload')">自动上传账号配置</ElButton>
          <ElButton v-if="authAddBtn" type="primary" @click="$emit('on-add')">新建人群包</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { isEmpty, trim } from '@/common/js/utils'
import { initPageData, SYS_USERS } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS])

export default {
  name: 'DmpFilter',
  props: {
    loading: {
      type: Boolean
    },
    platformData: {
      type: Array
    },
    statData: {
      type: Array
    },
    authAddBtn: {
      type: Boolean
    },
    authBatchBtn: {
      type: Boolean
    }
  },
  data() {
    return {
      opId: '',
      upId: '',
      stats: '',
      platform: '',
      keyword: ''
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS
  },
  methods: {
    sendEvent() {
      const params = {
        keyword: isEmpty(this.keyword) ? undefined : trim(this.keyword),
        opId: this.opId === '' ? undefined : this.opId,
        upOpId: this.upId === '' ? undefined : this.upId,
        status: this.stats === '' ? undefined : this.stats,
        platform: this.platform === '' ? undefined : this.platform
      }
      this.$emit('on-change', params)
    },
    onDropdownCmd(type) {
      if (type === '1') this.$emit('on-batch')
      if (type === '2') this.$emit('batch-del')
    },
    autoUpload(name) {
      this.$router.push({ name })
    }
  }
}
</script>
